import http from '@/plugins/http';
import mixpanel from '@/plugins/mixpanel';
import reportError from '@/utils/reportError';

export default (Form) => new Promise((res, rej) => {
  const updateUser = new FormData();
  updateUser.append('firstname', Form.firstname);
  updateUser.append('lastname', Form.lastname);
  updateUser.append('job_position', Form.post);
  updateUser.append('phone', Form.phone);
  if (Form.password) {
    updateUser.append('password', Form.password);
  }
  updateUser.append('picture', Form.image);
  updateUser.append('token', Form.token);

  if (Form.token) {
    mixpanel.track('Pop Team Invitation Confirmed');
    // depuis une invitation
    http.post(`/v3/users/${Form.email}/update-customer-user`, updateUser)
      .then((response) => {
        response.newMember = true;
        res(response);
      })
      .catch((error) => {
        reportError(error);
        rej(error);
      });
  } else {
    // Pour update le profil
    http.post('/v3/users/me/update-customer-user', updateUser)
      .then((response) => {
        res(response);
      })
      .catch((error) => {
        rej(error);
      });
  }
});
